import * as React from 'react';

import { Column } from '../../../common/Column';

interface ILayoutProps {
  columnCount?: number;
}

export const Layout: React.FC<React.PropsWithChildren<ILayoutProps>> = ({ children, columnCount = 3 }) => {
  const childrenArray = React.Children.toArray(children) as React.ReactElement[];
  const columns = childrenArray.reduce(
    (acc, item, index) => {
      const i = index % columnCount;

      acc[i].push(item);

      return acc;
    },
    Array.from({ length: columnCount }, (): React.ReactElement[] => []),
  );

  return (
    <>
      {columns.map((column, index: number) => (
        <Column key={`column_${index}`}>{column.map(child => React.cloneElement(child))}</Column>
      ))}
    </>
  );
};
